exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-request-it .loans-detail-request-it{text-align:justify;padding-top:18px;padding-right:70px}loans-detail-request-it .loans-detail-request-it.mobile{padding-right:0;text-align:left}loans-detail-request-it .loans-detail-request-it.mobile ul{list-style-position:unset;font-size:13px}loans-detail-request-it .loans-detail-request-it.mobile p{text-align:left}loans-detail-request-it .loans-detail-request-it ul{font-size:15px;list-style-position:inside}loans-detail-request-it .loans-detail-request-it .first-list{padding-top:10px;padding-left:26px}loans-detail-request-it .loans-detail-request-it .first-list li{padding-bottom:20px}loans-detail-request-it .loans-detail-request-it .second-list{list-style-type:decimal}loans-detail-request-it .loans-detail-request-it .second-list li{padding-left:10px;padding-bottom:20px}loans-detail-request-it .loans-detail-request-it .third-list{padding-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailRequestIt/loansDetailRequestIt.scss
// module id = 1858
// module chunks = 0